import actionCreatorFactory from 'typescript-fsa';
import { ApiFieldError } from 'src/types';

export const actionCreator = actionCreatorFactory(
  `@@LENDSMARTMANAGER/TASKSLOANAPPS`
);
export type APIError = ApiFieldError;

export type UpdateTaskParams = any;
export type CreateTaskPayload = any;



export const createTaskActions = actionCreator.async<
  CreateTaskPayload,
  any,
  APIError[]
>(`create`);

export const updateTaskActions = actionCreator.async<
  UpdateTaskParams,
  any,
  APIError[]
>(`update`);
